"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/common/contexts/index.ts
var contexts_exports = {};
__export(contexts_exports, {
  DropdownProviderWrapper: () => DropdownProviderWrapper,
  ThemeProvider: () => ThemeProvider,
  useDropdownContext: () => useDropdownContext,
  useTheme: () => useTheme
});
module.exports = __toCommonJS(contexts_exports);

// src/common/contexts/DropdownContext.tsx
var import_react = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var DropdownContext = (0, import_react.createContext)({
  activeDropdownName: "",
  /**
   * This is a dummy function to satisfy the type checker
   * */
  setActiveDropdownName: (name) => {
  }
});
var useDropdownContext = () => (0, import_react.useContext)(DropdownContext);
var DropdownProviderWrapper = ({
  children
}) => {
  const [activeDropdownName, setActiveDropdownName] = (0, import_react.useState)("");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    DropdownContext.Provider,
    {
      value: { activeDropdownName, setActiveDropdownName },
      children
    }
  );
};

// src/common/contexts/ThemeContext.tsx
var import_react2 = require("react");
var import_jsx_runtime2 = require("react/jsx-runtime");
var ThemeContext = (0, import_react2.createContext)(void 0);
var useTheme = () => {
  const context = (0, import_react2.useContext)(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
var ThemeProvider = ({ children }) => {
  const [theme, setTheme] = (0, import_react2.useState)("Light");
  const toggleTheme = () => {
    setTheme((prevTheme) => prevTheme === "Light" ? "Dark" : "Light");
  };
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(ThemeContext.Provider, { value: { theme, toggleTheme, setTheme }, children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { "data-theme": theme, children }) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DropdownProviderWrapper,
  ThemeProvider,
  useDropdownContext,
  useTheme
});
//# sourceMappingURL=index.js.map